import React from "react";

export const ConditionalWrapper = ({ condition, Wrapper, children }) => {
  return condition ? <Wrapper>{children}</Wrapper> : children;
};
